import { combineReducers } from 'redux';
import { authReducer, deviceReducer, geofenceReducer, usersReducer } from './reducers';
import languageReducer from './reducers/languageReducer';

const rootReducer = combineReducers({
    authReducer,
    language: languageReducer,
    users: usersReducer,
    devices: deviceReducer,
    geofence: geofenceReducer,
})

export default rootReducer